import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { toast } from "react-toastify";
import DeleteAccount from "./component";
import { useApiRequest } from "../Login/Hooks/useApiRequest";
import NoInternet from "../../NoInterNet/component";
const DeleteAccountContainer = (props) => {
   const { makeApiRequest } = useApiRequest()
  const navigate=useNavigate()
  const [logoutModal, setLogutModal] = useState(false);
  const [reason,setReason]=useState(null)
    const [loader,setLoader]=useState(false)

useEffect(()=>{
  
  
},[])




  // ✅ Offline state — drives the NoInternet screen
  const [noInternet, setNoInternet] = useState(false);


        const handleNetworkError = (error) => {
    if (error.code === "ERR_NETWORK" || !error.response) {
      setNoInternet(true);
      setLoader(false);
      return true;
    }
    return false;
  };


    
        // ─── Online / offline listeners ───────────────────────────────────────────

  useEffect(() => {
    if (!navigator.onLine) {
      setNoInternet(true);
      setLoader(false);
    }

    const goOffline = () => setNoInternet(true);
    const goOnline = () => {
      setNoInternet(false);
      //setLoader(true);
   
 

    };

    window.addEventListener("offline", goOffline);
    window.addEventListener("online", goOnline);
    return () => {
      window.removeEventListener("offline", goOffline);
      window.removeEventListener("online", goOnline);
    };
  }, []);



const UserJWTAuth = localStorage.getItem('UserJWTAuth');
useEffect(()=>{
 
 //logger.log("UserJWTAuth BusinessPaymentContainer",UserJWTAuth)
 if(!UserJWTAuth){
  localStorage.setItem("enteryUrl",'/deleteaccount')
   navigate('/')
 }
},[])

useEffect(()=>{
 
  //logger.log("UserJWTAuth BusinessPaymentContainer",UserJWTAuth)
  if(localStorage.getItem('Guest_clientId')){
    //navigate('/login')
  }
 },[])
 
//





 









const handleErrordeleteAccountApi =(error)=>{
  //logger.log("khan handleErrorVmInventory", error.response.data.status.code);
  if(error.response.status==401|| error.response.status==403){

    //logger.log("khan handleErrorVmInventory", error.response.data.status.code);
    //Logout
    //localStorage.removeItem("UserJWTAuth")
     // navigate("/login");
}
else{ toast.error(`${error&&error.response&&error.response.data&&error.response.data.status}`, {
  position: "top-right",
  autoClose: 1000,
});
}
  
  //setLoader(false)
  
}

const handleResponsedeleteAccountApi =(res)=>{
 setLogutModal(false)
 toast.success(`sucess`, {
    position: "top-right",
    autoClose: 1000,
  });
  //setLoader(false)
  //setLoader(false)
  //localStorage.removeItem('UserJWTAuth')
  navigate('/profile')
}

const deleteAccountApi = () => {
  const UserJWTAuth = localStorage.getItem("UserJWTAuth");




    makeApiRequest({
        url: `${process.env.REACT_APP_API_BASE_URL}/auth/user/request/delete`,
     method: "POST",
             headers: {
          Authorization: `Bearer ${UserJWTAuth}`,
        },
        data:{
    
        "reason": reason


      },
      handleSuccess: (res) => handleResponsedeleteAccountApi(res),
      handleError:(error)=> handleErrordeleteAccountApi(error),
    });

};









  if (noInternet) return <NoInternet />;




return(
    <DeleteAccount
    deleteAccountApi={deleteAccountApi}
    logoutModal={logoutModal}
    setLogutModal={setLogutModal}
    setReason={setReason}
 />
)


}




  export default  DeleteAccountContainer